import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers'

const endpoint = 'v1/t/loop'

/**
 * @param {string} toteId
 * @return {{[p: string]: *}}
 */
export function useToteLoopMutation(toteId) {
  const values = useGenericRequestHandler({
    route: endpoint + `/${toteId}`,
    method: 'POST'
  })

  return withEngagingURL(values)
}
